module.exports = __webpack_public_path__ + "static/img/icon_scan.7ea0c05a.png";